module.exports = __webpack_public_path__ + "static/media/10.88080563.jpg";